import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

export default function Landing() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/auth?action=signup');
  };

  const handleSignIn = () => {
    navigate('/auth?action=login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5">
      {/* Header */}
      <header className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between overflow-visible">
          <div className="flex items-center gap-3 overflow-visible">
            <div className="w-[75px] h-[75px] rounded-full bg-gradient-primary shadow-glow flex items-center justify-center">
              <img
                src="/logos/pink_dolphin_logo.png"
                alt="Pink Dolphin logo"
                className="h-16 w-16 object-contain"
              />
            </div>
            <div
              className="h-[60px] min-w-[160px] max-w-[240px] flex-1 overflow-visible bg-gradient-to-r from-primary to-tertiary py-1 -translate-x-1 -translate-y-1"
              style={{
                WebkitMaskImage: "url('/logos/pink_dolphin_text.png')",
                maskImage: "url('/logos/pink_dolphin_text.png')",
                WebkitMaskSize: "contain",
                maskSize: "contain",
                WebkitMaskRepeat: "no-repeat",
                maskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                maskPosition: "center",
              }}
              role="img"
              aria-label="Pink Dolphin Tracker - Professional Trading Card Analytics"
            />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <main className="container mx-auto px-4 py-10 md:py-10">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-primary via-tertiary to-secondary bg-clip-text text-transparent">
            Track Your Trading Card Investments
          </h2>
          <p className="text-xl md:text-2xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Track inventory, analyze performance, and make data-driven decisions.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Button 
              onClick={handleGetStarted}
              size="lg"
              className="text-lg px-8 py-6 bg-primary hover:bg-primary-dark shadow-lg hover:shadow-xl transition-all"
            >
              Start Free Trial
            </Button>
            <Button 
              onClick={handleSignIn}
              size="lg"
              variant="outline"
              className="text-lg px-8 py-6 border-2 hover:bg-accent transition-all"
            >
              Sign In
            </Button>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          <Card className="border-2 hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <span className="text-2xl">📊</span>
              </div>
              <CardTitle>Advanced Analytics</CardTitle>
              <CardDescription>
                Track ROI, profit margins, and performance metrics across your entire collection
              </CardDescription>
            </CardHeader>
          </Card>

          <Card className="border-2 hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center mb-4">
                <span className="text-2xl">📦</span>
              </div>
              <CardTitle>Inventory Management</CardTitle>
              <CardDescription>
                Organize and track your cards from purchase through grading to sale
              </CardDescription>
            </CardHeader>
          </Card>

          <Card className="border-2 hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="w-12 h-12 rounded-lg bg-tertiary/10 flex items-center justify-center mb-4">
                <span className="text-2xl">📈</span>
              </div>
              <CardTitle>Custom Dashboards</CardTitle>
              <CardDescription>
                Build personalized dashboards to visualize your data exactly how you need it
              </CardDescription>
            </CardHeader>
          </Card>
        </div>

        {/* Pricing Section */}
        <div className="max-w-2xl mx-auto">
          <Card className="border-2 border-primary/20 bg-gradient-to-br from-card to-primary/5">
            <CardHeader className="text-center">
              <CardTitle className="text-3xl mb-2">Pricing</CardTitle>
              <CardDescription className="text-lg">
                Start with a 90-day free trial, then just $5/month
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center space-y-4">
              <div className="text-5xl font-bold text-primary mb-2">$5<span className="text-2xl text-muted-foreground">/month</span></div>
              <ul className="text-left space-y-2 max-w-md mx-auto">
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  <span>90-day free trial - no credit card required</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  <span>Unlimited inventory tracking</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  <span>Advanced analytics and reporting</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  <span>Custom dashboards and visualizations</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  <span>Tax reporting and expense tracking</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}
